import React from "react";

function Card({ source, title, summary, url,repo }) {
  return (
    <>
      <div className="max-w-sm bg-white border border-violet-600 rounded-lg shadow dark:bg-black dark:border-violet-600">
        <img
          className="rounded-t-lg object-cover h-72 w-96 ..."
          src={source}
          alt=""
        />
        <div className="p-5">
          <h5 className="mb-2 text-2xl font-bold tracking-tight text-violet-600">
            {title}
          </h5>
          <p className="mb-3 font-normal text-black dark:text-white">
            {summary}
          </p>
          <button
            onClick={() => ( window.open(url))}
            href={url}
            className="relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium transition-all bg-violet-600 rounded hover:bg-violet-600 group border-violet-600"
          >
            <span className="w-48 h-48 rounded rotate-[-40deg] bg-white dark:bg-black absolute bottom-0 left-0 -translate-x-full ease-out duration-500 transition-all translate-y-full mb-9 ml-9 group-hover:ml-0 group-hover:mb-32 group-hover:translate-x-0"></span>
            <span className="relative w-full text-left text-white dark:text-black transition-colors duration-300 ease-in-out group-hover:text-violet-600 ">
              Demo
            </span>
          </button>{" "}
          <button
            onClick={() => ( window.open(repo))}
            href="src"
            className="relative inline-flex items-center justify-start px-6 py-3 overflow-hidden font-medium transition-all bg-violet-600 rounded hover:bg-violet-600 group border-violet-600"
          >
            <span className="w-48 h-48 rounded rotate-[-40deg] bg-white dark:bg-black absolute bottom-0 left-0 -translate-x-full ease-out duration-500 transition-all translate-y-full mb-9 ml-9 group-hover:ml-0 group-hover:mb-32 group-hover:translate-x-0"></span>
            <span className="relative w-full text-left text-white dark:text-black transition-colors duration-300 ease-in-out group-hover:text-violet-600 ">
              Github
            </span>
          </button>{" "}
        </div>
      </div>
    </>
  );
}

export default Card;
